// non-shad component

import { cn } from "@workspace/ui/lib/utils";
import { Loader2 } from "lucide-react";

export function LoadingSpinner({ className }: { className?: string }) {
  return (
    <div role="status">
      <Loader2
        className={cn("text-brand-600 size-4 animate-spin", className)}
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
}
